import React from 'react';
import { ThemeConfig } from '@/types';

interface ThemePreviewProps {
  theme: ThemeConfig;
}

export function ThemePreview({ theme }: ThemePreviewProps) {
  const isDark = isColorDark(theme.background);
  const textColor = isDark ? '#F9FAFB' : '#1F2937';
  const subtextColor = isDark ? '#D1D5DB' : '#6B7280';

  return (
    <div
      className="rounded-xl border border-gray-200 overflow-hidden shadow-sm"
      style={{ backgroundColor: theme.background }}
    >
      {/* Header preview */}
      <div
        className="px-6 py-4 flex items-center justify-between"
        style={{ backgroundColor: theme.primary_color }}
      >
        <span
          className="text-sm font-bold"
          style={{ color: '#FFFFFF', fontFamily: `'${theme.font_family}', serif` }}
        >
          Event Name
        </span>
        <div
          className="px-3 py-1 rounded-full text-xs font-medium"
          style={{ backgroundColor: theme.accent_color, color: '#FFFFFF' }}
        >
          RSVP
        </div>
      </div>

      {/* Content preview */}
      <div className="p-6 space-y-4">
        <h3
          className="text-xl font-bold"
          style={{ color: textColor, fontFamily: `'${theme.font_family}', serif` }}
        >
          Your Event Title
        </h3>
        <p className="text-sm" style={{ color: subtextColor }}>
          Saturday, 15 March 2026 at 4:00 PM
        </p>
        <p className="text-sm" style={{ color: subtextColor }}>
          This is a preview of how your event page will look with the selected theme.
        </p>

        {/* Button previews */}
        <div className="flex gap-3 pt-2">
          <button
            className="px-4 py-2 rounded-lg text-sm font-medium text-white"
            style={{ backgroundColor: theme.primary_color }}
          >
            Primary
          </button>
          <button
            className="px-4 py-2 rounded-lg text-sm font-medium border-2"
            style={{
              borderColor: theme.secondary_color,
              color: theme.secondary_color,
            }}
          >
            Secondary
          </button>
          <button
            className="px-4 py-2 rounded-lg text-sm font-medium text-white"
            style={{ backgroundColor: theme.accent_color }}
          >
            Accent
          </button>
        </div>
      </div>
    </div>
  );
}

function isColorDark(hex: string): boolean {
  const color = hex.replace('#', '');
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
}
